import { Routes, Route, useLocation, matchPath } from 'react-router-dom';

import App from './components/App';
import stt from './components/withScrollToTopOnMount';
import Home from './components/Home';
import TaskListView from './components/tasklist/TaskListView';
import TaskView from './features/task/TaskView';
import ServiceContainer from './features/ServiceContainer';
import OrderIsDone from './forms/views/OrderIsDone';
import FeedbackView from './features/feedback/FeedbackView';
import NotificationsRoute from './features/drawer/route/NotificationsRoute';
import Onboarding from './components/Onboarding';
import ExternalSystemModal from './components/ExternalSystemModal';
import ConfirmCompleteModal from './components/ConfirmCompleteModal';

const SttHome = stt(Home);
const SttTaskListView = stt(TaskListView);
const SttTaskView = stt(TaskView);
const SttOrderIsDone = stt(OrderIsDone);
const SttFeedbackView = stt(FeedbackView);
const SttNotificationsRoute = stt(NotificationsRoute);
const SttOnboarding = stt(Onboarding);

const AppRoutes = () => {
  const location = useLocation();
  const previousLocation = location.state?.previousLocation;

  const modalComponents = [
    { path: '/linkkimodaali', element: <ExternalSystemModal /> },
    {
      path: '/tilaukset/:orderId/valmis',
      element: <ConfirmCompleteModal />,
    },
  ];

  return (
    <>
      <App>
        <Routes
          location={
            // Show previous location under the modal when one is open
            modalComponents.find(
              ({ path }) => matchPath(path, location.pathname) !== null
            )
              ? previousLocation
              : location
          }
        >
          <Route path="/" element={<SttHome />} />
          <Route path="/tilauslista" element={<SttTaskListView />} />
          <Route path="/tilauslista/:id" element={<SttTaskView />} />
          {/* stt is handled within service container */}
          <Route path="/palvelut/*" element={<ServiceContainer />} />
          <Route path="/valmis" element={<SttOrderIsDone />} />
          <Route path="/palaute" element={<SttFeedbackView />} />
          <Route
            path="/ilmoitukset/:notificationId"
            element={<SttNotificationsRoute />}
          />
        </Routes>
      </App>

      {/* TODO: refactor under modal components */}
      <Routes>
        <Route path="/onboarding/*" element={<SttOnboarding />} />
      </Routes>

      <Routes>
        {modalComponents.map(({ path, element }) => (
          <Route key={path} path={path} element={element} />
        ))}
      </Routes>
    </>
  );
};

export default AppRoutes;
